/**
 * Este arquivo contém métodos utilitários para facilitar a obtenção de status relacionados ao budget.
 */

/**
 * This validation works for both external and internal Budget.
 * @param {Object} budget Object
 * @param {Boolean} isInternal if is internal Budget or not
 */
function verifyBudgetIsTemporarySaved(budget, throwError = false) {
  if (!budget && throwError) {
    throw new Error('budget must be defined')
  }
  return !!budget?.isOriginal
}

/**
 * @param {Object} budget Object
 * @returns `true` if Budget is internal; `false` if budget is external.
 */
function verifyBudgetIsInternal(budget) {
  return !!budget?.proposeOpened
}

/**
 * There may have other ways to validate not using URL, but for now it works
 * @param {string} pathname Validate via URL path
 */
function verifyBudgetIsSaved(pathname) {
  return !pathname.includes('/novo')
}

/**
 * There may have other ways to validate not using URL, but for now it works
 * @tags ifCreating, sendo cadastrado
 * @param {string} pathname  Validate via UR Lpath
 */
function verifyBudgetIsRegistering(pathname) {
  return pathname.includes('/novo')
}

/**
 * There may have other ways to validate not using URL, but for now it works
 * @param {string} pathname Validate via URL path
 */
function verifyBudgetIsActive(pathname) {
  return !pathname.includes('/novo')
}

/**
 * @param {string} pathname Validate via URL path
 */
export function verifyBudgetFromPath(pathname) {
  return {
    budgetIsTemporarySaved: verifyBudgetIsTemporarySaved(pathname),
    budgetIsSaved: verifyBudgetIsSaved(pathname),
    budgetIsRegistering: verifyBudgetIsRegistering(pathname),
    budgetIsActive: verifyBudgetIsActive(pathname),
  }
}

/**
 * @param { Object } budget Validate via budget object
 */
export function verifyBudget(budget) {
  return {
    budgetIsInternal: verifyBudgetIsInternal(budget),
  }
}
